import { watch, reactive } from 'vue';
const proxy = (obj) => {
    return reactive({
        value: obj,
    });
};
const subscribe = watch;
export { proxy, subscribe, };
